(() => {
  const REDIRECT_PARAM = 'eql_entry';
  const MAX_TIMER_DELAY = 60 * 60 * 1000;

  function removeRedirectParam(url) {
    url.searchParams.delete(REDIRECT_PARAM);
    const cleanUrl = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState(window.history.state, '', cleanUrl);
  }

  function scheduleStateRefresh(productSection) {
    const serverNow = Number(productSection.dataset.lotteryServerNow);
    const nextTransition = Number(productSection.dataset.lotteryNextTransition);

    if (!Number.isFinite(serverNow) || !Number.isFinite(nextTransition)) return;

    const renderedAt = Date.now();
    const transitionAt = nextTransition * 1000;
    const serverNowAtRender = serverNow * 1000;

    const checkTransition = () => {
      const serverNowEstimate = serverNowAtRender + (Date.now() - renderedAt);
      const remaining = transitionAt - serverNowEstimate;

      if (remaining <= 0) {
        const reloadKey = `lottery-transition-${window.location.pathname}-${nextTransition}`;

        try {
          if (window.sessionStorage.getItem(reloadKey)) return;
          window.sessionStorage.setItem(reloadKey, '1');
        } catch (error) {
          // sessionStorageが利用できない場合も、状態更新のため再読み込みする。
        }

        window.location.reload();
        return;
      }

      window.setTimeout(checkTransition, Math.min(remaining + 250, MAX_TIMER_DELAY));
    };

    checkTransition();
  }

  function initializeLotteryProduct() {
    const productSection = document.querySelector('[data-lottery-product]');
    if (!productSection) return;

    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get(REDIRECT_PARAM) === '1') {
      const entryUrl = productSection.dataset.lotteryEntryUrl;
      const isLotteryActive = productSection.dataset.lotteryState === 'active';

      removeRedirectParam(currentUrl);

      if (isLotteryActive && entryUrl) {
        window.location.assign(entryUrl);
        return;
      }
    }

    scheduleStateRefresh(productSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLotteryProduct, { once: true });
  } else {
    initializeLotteryProduct();
  }
})();
